import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  Tabs, 
  Tab, 
  Paper,
  Container
} from '@mui/material';
import {
  DirectionsBike,
  Settings,
  CalendarToday
} from '@mui/icons-material';

// Import dei componenti delle tab
import RentalManagement from '../components/rental/RentalManagement';
import VehicleFleet from '../components/rental/VehicleFleet';
import RentalCalendar from '../components/rental/RentalCalendar';
import RentalSettings from '../components/rental/RentalSettings';

const Rental = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const tabs = [
    {
      label: 'Gestione Noleggi',
      icon: <DirectionsBike />,
      component: <RentalManagement />
    },
    {
      label: 'Parco Mezzi',
      icon: <DirectionsBike />,
      component: <VehicleFleet />
    },
    {
      label: 'Calendario',
      icon: <CalendarToday />,
      component: <RentalCalendar />
    },
    {
      label: 'Impostazioni',
      icon: <Settings />,
      component: <RentalSettings />
    }
  ];

  return (
    <Box sx={{ width: '100%', minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      <Container maxWidth="xl" sx={{ py: 3 }}>
        {/* Header */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Sezione Noleggio
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Gestisci i noleggi e il parco mezzi
          </Typography>
        </Box>

        {/* Tabs */}
        <Paper sx={{ width: '100%', mb: 3 }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              '& .MuiTab-root': {
                minHeight: 64,
                textTransform: 'none',
                fontSize: '1rem',
                fontWeight: 500
              }
            }}
          >
            {tabs.map((tab, index) => (
              <Tab
                key={index}
                label={tab.label}
                icon={tab.icon}
                iconPosition="start"
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: 1
                }}
              />
            ))}
          </Tabs>
        </Paper>

        {/* Tab Content */}
        <Box sx={{ width: '100%' }}>
          {tabs[activeTab].component}
        </Box>
      </Container>
    </Box>
  );
};

export default Rental;
